import { loadJS, loadCSS } from "./utils.js";
import GLightbox from "../glightbox/js/glightbox.js";

window.tiny_slider_assets = false;

function loadAssets(callback) {
  if (window.tiny_slider_assets) {
    callback();
    return;
  }

  loadCSS(
    "https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.3/tiny-slider.min.css"
  );

  loadJS(
    "https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.3/tiny-slider.min.js",
    function () {
      window.tiny_slider_assets = true;
      callback();
    }
  );
}
export function setupGalerias() {
  //versión nueva, con https://github.com/ganlanyuan/tiny-slider
  setTimeout(function () {
    loadAssets(function () {
      //TODO: convertir a esto en un multi galeria (páginas con varias galerías)
      if (!document.querySelector(".blocks-gallery-grid")) return;

      const galerias = document.querySelectorAll(".blocks-gallery-grid");

      window.sliders = [];
      let galeria_indice = 0;
      for (const galeria of galerias) {
        window.sliders.push(
          tns({
            container: galeria,
            items: 1,
            center: false,
            loop: true,
            swipeAngle: false,
            speed: 400,
            // gutter: 0,
            // edgePadding: 5,
            // fixedWidth: 300,
            controls: false,
            nav: false,
            lazyload: true,
            autoHeight: false,
            mouseDrag: true,
            /*responsive: {
                        970: {
                            items: 2,
                            fixedWidth: false,
                            gutter: 0,
                            // edgePadding: 50,
                        },
                    },*/
          })
        );

        galeria.attributes.galeria_indice = galeria_indice;

        // window.sliders.push(slider);
        var slider = window.sliders[galeria_indice];

        const slider_info = slider.getInfo();
        const slider_parent = slider_info.container.closest(".galeria_fotos");

        // if (slider_parent) {
        if (false) {
          const slider_textos = slider_parent.querySelector(
            ".galeria_fotos__navegacion__texto"
          );
          const slider_textos_actual = slider_textos.querySelector(".actual");
          const slider_textos_total = slider_textos.querySelector(".total");
          slider_textos_total.innerHTML = slider_info.slideCount;
        }

        slider_info.slideItems[slider_info.index].classList.add(
          "tns-item-active"
        );

        for (const slide of slider_info.slideItems) {
          slide.addEventListener("click", function (e) {
            e.preventDefault();

            const gallery = slide.closest(".blocks-gallery-grid");
            galeriaZoom(e, gallery, galeria_indice);
          });

          const zoom_btn = slide.querySelector;
        }

        slider.events.on("indexChanged", function (info) {
          info.slideItems[info.indexCached].classList.remove("tns-item-active");

          info.slideItems[info.index].classList.add("tns-item-active");

          /*const slider_info = slider.getInfo();
                    const slider_parent =
                        slider_info.container.closest(".galeria_fotos");
                    if (!slider_parent) return;
                    const slider_textos = slider_parent.querySelector(
                        ".galeria_fotos__navegacion__texto"
                    );
                    const slider_textos_actual =
                        slider_textos.querySelector(".actual");
                    slider_textos_actual.innerHTML = slider_info.displayIndex;*/
        });

        if (slider_parent) {
          const slider_next = slider_parent.querySelector(
            ".galeria_fotos__navegacion__flecha--siguiente"
          );
          slider_next.addEventListener("click", function (e) {
            e.preventDefault();
            slider.goTo("next");
          });

          const slider_prev = slider_parent.querySelector(
            ".galeria_fotos__navegacion__flecha--anterior"
          );
          slider_prev.addEventListener("click", function (e) {
            e.preventDefault();
            slider.goTo("prev");
          });
        }
        galeria_indice++;
      }
    });
  }, 500); //settimeout
}

function galeriaZoom(e, gallery = "", galeria_indice = "") {
  e.preventDefault();

  const modal = document.querySelector(".zoom_imagen_modal");
  const modal_img = modal.querySelector(".zoom_imagen_modal__body img");
  const modal_fc = modal.querySelector(".zoom_imagen_modal__body p");
  const modal_body = document.querySelector(".zoom_imagen_modal__body");
  const modal_cerrar = document.querySelector(".zoom_imagen_modal__cerrar");

  const slide = e.currentTarget;
  gallery = slide.closest(".blocks-gallery-grid");
  const indice = gallery.attributes.galeria_indice;

  var galeria_textos_actual = 0;

  var slider = window.sliders[indice];
  const info = slider.getInfo();
  galeria_textos_actual = info.displayIndex - 1;
  // console.log({ galeria_textos_actual });

  const nuevo_html = info.container.cloneNode(true);

  modal_body.innerHTML =
    '<ul class="blocks-gallery-grid">' + nuevo_html.innerHTML + "</ul>";

  const items = modal_body.querySelectorAll(".blocks-gallery-item");
  for (const item of items) {
    if (item.classList.contains("tns-slide-cloned")) {
      item.remove();
      continue;
    }

    item.classList.remove("tns-item", "tns-slide-active");
    item.removeAttribute("id");

    const imagen = item.querySelector("img");
    imagen.src = imagen.dataset.fullUrl;
  }

  window.modal_slider = tns({
    container: ".zoom_imagen_modal .blocks-gallery-grid",
    items: 1,
    center: false,
    loop: true,
    swipeAngle: false,
    speed: 400,
    controls: false,
    nav: false,
    lazyload: true,
    autoHeight: false,
    mouseDrag: true,
    startIndex: galeria_textos_actual,
  });

  modal_cerrar.addEventListener("click", function () {
    const modal = document.querySelector(".zoom_imagen_modal");
    modal.classList.remove("abierto");
    modal.classList.remove("cargando");
  });

  modal.classList.add("abierto");
  modal.classList.add("cargando");
}

//galerías

//galería como destacada
/*galeria_destacada = document.querySelectorAll('.gallery');
			for (const galeria of galeria_destacada) {
				galeria.classList.add('wp-block-gallery');
				var items = galeria.querySelectorAll('.gallery-item');
				for (const item of items) {
					item.classList.add('blocks-gallery-item');
				}
			}*/

export const setupGlightbox = () => {
  if (document.body.classList.contains("page-detail")) {
    console.log("clinica");
    const lightbox = GLightbox();
  }
};
